import React from "react";
import SignatureCanvas from "react-signature-canvas";
import {
  HiOutlineCheckCircle,
  HiOutlineRefresh,
  HiOutlineUpload,
  HiOutlineX,
} from "react-icons/hi";

const SignatureModal = ({
  isOpen,
  signed,
  signatureModalRef,
  signatureUploadRef,
  signatureInputMode,
  signaturePreviewUrl,
  onClose,
  onClear,
  onUpload,
  onSaveFromPad,
}) => {
  if (!isOpen || signed) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/70 px-3 py-4">
      <div className="flex max-h-[92vh] w-full max-w-3xl flex-col rounded-lg border border-gray-200 bg-white shadow-2xl dark:border-gray-700 dark:bg-gray-900">
        <div className="flex items-center justify-between gap-3 border-b border-gray-200 px-4 py-3 dark:border-gray-800">
          <div>
            <h2 className="text-base font-bold text-gray-900 dark:text-white">
              Customer Signature
            </h2>
            <p className="text-xs text-gray-500 dark:text-gray-400">
              Sign inside the box below.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-gray-200 text-gray-600 transition hover:border-gray-300 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
            aria-label="Close signature popup"
          >
            <HiOutlineX className="h-5 w-5" />
          </button>
        </div>

        <div className="p-4">
          <div
            className="relative h-[46vh] min-h-[280px] max-h-[520px] overflow-hidden rounded-md border-2 border-blue-500 bg-white shadow-inner"
            style={{ touchAction: "none" }}
          >
            <SignatureCanvas
              ref={signatureModalRef}
              clearOnResize={false}
              penColor="#1d4ed8"
              minWidth={0.8}
              maxWidth={2.4}
              velocityFilterWeight={0.75}
              onEnd={() => {
                if (signatureInputMode === "draw") {
                  onSaveFromPad(signatureModalRef.current);
                }
              }}
              canvasProps={{
                className: `h-full w-full ${
                  signatureInputMode === "upload" ? "pointer-events-none" : ""
                }`,
                style: { touchAction: "none" },
                "aria-label": "Large customer signature box",
              }}
            />
            {signatureInputMode === "upload" && signaturePreviewUrl && (
              <img
                src={signaturePreviewUrl}
                alt="Uploaded customer signature"
                className="pointer-events-none absolute inset-0 h-full w-full object-contain p-5"
              />
            )}
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-gray-200 px-4 py-3 dark:border-gray-800 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <input
              ref={signatureUploadRef}
              type="file"
              accept="image/*"
              onChange={onUpload}
              className="hidden"
            />
            <button
              type="button"
              onClick={() => signatureUploadRef.current?.click()}
              className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-700 transition hover:border-blue-300 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
            >
              <HiOutlineUpload className="h-4 w-4" />
              Upload
            </button>
          </div>

          <div className="flex items-center justify-end gap-2">
            <button
              type="button"
              onClick={onClear}
              className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-semibold text-gray-700 transition hover:border-blue-300 hover:text-blue-700 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200"
            >
              <HiOutlineRefresh className="h-4 w-4" />
              Clear
            </button>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center gap-1.5 rounded-md bg-blue-600 px-4 py-2 text-sm font-bold text-white transition hover:bg-blue-700"
            >
              <HiOutlineCheckCircle className="h-5 w-5" />
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignatureModal;
